import { createEntitySlice, IStoreEntityStateSlice } from '@core-lib/store/entity-slice.function';

export interface IInitStoreState {
	isInitLoading: boolean;
	isInitFinished: boolean;
}

export const initialState: IInitStoreState = {
	isInitLoading: false,
	isInitFinished: false
};
